import { apiRequest } from './_tools';

export function fetchLogs({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/logs?page=${page}` +
    `&dateFrom=${filter.date.from}` +
    `&dateTo=${filter.date.to}` +
    `&error=${filter.error}` +
    `&description=${filter.description}` +
    `&exception=${filter.exception}` +
    `&platform=${filter.platform}` +
    `&osVersion=${filter.osVersion}` +
    `&sdkVersion=${filter.sdkVersion}` +
    `&appId=${filter.appId}` +
    `&appName=${filter.appName}` +
    `&userId=${filter.userId}` +
    `&country=${filter.country}` +
    `&itemsPerPage=${itemsPerPage}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/logs.js
 **/